import React from 'react';
import Modal from './Modal';
import Button from './Button';

export interface ImportResults {
    added: number;
    updated: number;
    names?: string[];
}

interface ImportResultsModalProps {
    isOpen: boolean;
    onClose: () => void;
    results: ImportResults | null;
    title: string;
}

const ImportResultsModal: React.FC<ImportResultsModalProps> = ({ isOpen, onClose, results, title }) => {
    if (!isOpen || !results) return null;

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={title}>
            <div className="text-gray-900 dark:text-white space-y-4">
                <div className="text-center">
                    <p className="text-lg">Import complete!</p>
                    <div className="flex justify-center gap-8 mt-4">
                        <div>
                            <p className="text-3xl font-bold text-green-500">{results.added}</p>
                            <p className="text-sm text-gray-500 dark:text-gray-400">Records Added</p>
                        </div>
                        <div>
                            <p className="text-3xl font-bold text-blue-500">{results.updated}</p>
                            <p className="text-sm text-gray-500 dark:text-gray-400">Records Updated</p>
                        </div>
                    </div>
                </div>

                {results.names && results.names.length > 0 && (
                    <div>
                        <h4 className="font-semibold mb-2">Details:</h4>
                        <ul className="max-h-48 overflow-y-auto bg-gray-100 dark:bg-gray-900/50 p-2 rounded-md text-sm">
                            {results.names.map((name, index) => (
                                <li key={index} className="truncate">{name}</li>
                            ))}
                        </ul>
                    </div>
                )}
                
                <div className="flex justify-end pt-4">
                    <Button onClick={onClose}>OK</Button>
                </div>
            </div>
        </Modal>
    );
};

export default ImportResultsModal;